import { useEffect } from 'react';
import { useSearchContext } from '@/context/search';

export default () => {
  const [{ activeTab, filters }] = useSearchContext();
  useEffect(() => {
    const items = document.querySelectorAll('.js-search-tabs-count');
    const totalCountEl = document.getElementById('js-search-total-count');
    if (totalCountEl && items && filters && filters.count) {
      let countTabs = 0;
      Array.from(items).forEach(item => {
        if (item.id === activeTab.countId) item.innerHTML = filters.count;
        else countTabs += parseInt(item.textContent, 10);
      });
      totalCountEl.innerHTML = countTabs + filters.count;
    }
  }, [filters]);
};
